module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('block', {
    attrs: {
      "id": "education",
      "title": "Formation"
    }
  }, [_c('timeline', _vm._l((_vm.educations), function(education) {
    return _c('timeline-item', [_c('b', [_vm._v(_vm._s(education.date))]), _vm._v(" - "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(education.title)
      }
    })])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ba6c39e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Education.vue
// module id = 291
// module chunks = 1